import React from "react";
import {inject} from "mt-react-decorators";

@inject(['manager'])
export default class SectionAverage extends React.Component {

    get manager() {
        return this.props.manager;
    }

    get section() {
        return this.props.section;
    }

    get average() {
        return this.props.manager.getAverageValue(this.section, this.manager.year) || 1;
    }

    render() {
        return (
            <div className={'mtt-sustainability-tool__row mtt-sustainability-tool__row--highlight'}>
                <div className={'mtt-sustainability-tool__row-header'}>Average score:</div>
                <div className={'mtt-sustainability-tool__row-content'}>{this.average}</div>
            </div>
        );
    }
}